// Regla del proyecto (AGENTS.md, docs/CLIENTES.md): todo texto escrito por usuarios va en mayúsculas,
// buscadores incluidos. La interfaz lo aplica al escribir y la base de datos lo vuelve a forzar al
// guardar. Excepciones: el correo (al revés: minúsculas al escribir y al guardar) y la contraseña (no se
// modifica).

/** Mayúsculas con las reglas del español (tildes y ñ incluidas). */
export function upper(value: string): string {
  return value.toLocaleUpperCase('es');
}

/** Minúsculas para correos. */
export function lower(value: string): string {
  return value.toLowerCase();
}

/** Texto para comparar en búsquedas: sin tildes ni diferencias de mayúsculas ("presion" encuentra "PRESIÓN"). */
export function foldForSearch(value: string): string {
  return value.normalize('NFD').replace(/\p{M}/gu, '').toLocaleLowerCase('es').trim();
}

const PRESERVE_CASE_TYPES = new Set(['email', 'password']);

/** ¿Un input de este tipo se convierte a mayúsculas? */
export function uppercasesType(type: string | undefined): boolean {
  return !PRESERVE_CASE_TYPES.has(type ?? 'text');
}

/** ¿Un input de este tipo se convierte a minúsculas? Solo el correo. */
export function lowercasesType(type: string | undefined): boolean {
  return type === 'email';
}
